import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import api from "../../../services/api";

import Content from "../../../components/Content";
import ContentHeader from "../../../components/ContentHeader";
import CardHeader from "../../../components/CardHeader";
import CardFooter from "../../../components/CardFooter";
import { toast } from "react-toastify";
import Button from "../../../components/Button";

const PerfilNovo = (props) => {
  const [loading, setLoading] = useState(false);
  const [perfil, setPerfil] = useState(null);

  const history = useHistory();

  const getPerfilByPk = useCallback(() => {
    try {
      setLoading(true);
      api.get(`/profile/findByPk?id=${props.match.params.id}`).then((res) => {
        const p = res.data.data;
        setPerfil(p);
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [props.match.params.id]);


  useEffect(() => {
    if (props.match.params.id) {
      getPerfilByPk();
    }
  }, [getPerfilByPk, props.match.params.id]);

  const handleSubmit = function (e, errors, values) {
    if (errors.length === 0) {
      try {
        setLoading(true);
        if (!perfil.id) {
          api.post("/profile", perfil).then(() => {
            toast.success(`Novo perfil incluido com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            // getPerfil();
          });
        } else {
          api.put(`/profile`, perfil).then(() => {
            toast.success(`Perfil editado com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
          });
        }
        history.push("/profile");
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      errors.map((e) => {
        return toast.error(`Campo ${e} obrigatório`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
      });
    }
  };

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Perfis de Acesso"
      />
      <Content>
        <CardHeader
          title={"Perfis de Acesso"}
          icon={"fa-unlock-alt"}
          searchVisible={false}
        />

        <div className="box">
          <AvForm onSubmit={handleSubmit}>
            <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
              <div className="col-md-2">
                <div className="form-group">
                  <AvField
                    type="text"
                    name="Código"
                    label="Código"
                    value={perfil?.id || ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-md-10">
                <div className="form-group">
                  <AvField
                    type="text"
                    name="name"
                    label="Descrição *"
                    placeholder="Descrição"
                    value={perfil?.name || ""}
                    onChange={(e) =>
                      setPerfil({ ...perfil, name: e.target.value })
                    }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Digite a descrição.",
                      },
                    }}
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <CardFooter loading={loading}>
              <Button type="submit" title="Salvar" loading={loading} />

              <Button
                isCanceled
                type="button"
                title="Cancelar"
                loading={loading}
                onClick={() => history.push("/profile")}
              />
            </CardFooter>
          </AvForm>
        </div>
      </Content>
    </>
  );
};

export default PerfilNovo;
